import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const weightChange: AnswerPathTreeNode = { path: 'weightChange', nodeId: NodeIds.insuredWeightChange };
